@if (initialized && dto) {
    <div class="grid">

        <!-- Header: Partner / Status / Erstellt -->
        <div class="col-12">
            <hg-import-basic-details
                    [importDto]="dto"
                    (onOpenPartner)="openPartner()">
            </hg-import-basic-details>
        </div>

        <!-- Sektion: GDV-Datei -->
        <div class="col-12">
            <div class="surface-card p-3 border-round">
                <div class="flex align-items-center gap-2 mb-3">
                    <i class="fa-regular fa-file-lines text-primary"></i>
                    <span class="text-lg font-medium">GDV-Datei</span>
                </div>
                @if (dto.dmDocumentDtoId) {
                    <div class="flex align-items-center gap-3">
                        <span class="font-medium text-color-secondary">Dokument:</span>
                        <p-button
                                [label]="dto.dmDocumentDtoName || 'Dokument öffnen'"
                                icon="fa-regular fa-arrow-up-right-from-square"
                                severity="secondary"
                                [text]="true"
                                (onClick)="openDocument()">
                        </p-button>
                    </div>
                } @else {
                    <div class="text-color-secondary">Kein GDV-Dokument verknüpft.</div>
                }
            </div>
        </div>

        <!-- Sektion: Runtime-Snapshot (nur wenn vorhanden) -->
        @if (dto.runtimeSnapshotDocumentDtoId) {
            <div class="col-12">
                <div class="surface-card p-3 border-round">
                    <div class="flex align-items-center gap-2 mb-3">
                        <i class="fa-regular fa-camera text-primary"></i>
                        <span class="text-lg font-medium">Runtime-Snapshot</span>
                    </div>
                    <div class="flex align-items-center gap-3">
                        <span class="font-medium text-color-secondary">Snapshot:</span>
                        <p-button
                                [label]="dto.runtimeSnapshotDocumentDtoName || 'Snapshot öffnen'"
                                icon="fa-regular fa-arrow-up-right-from-square"
                                severity="secondary"
                                [text]="true"
                                (onClick)="openRuntimeSnapshot()">
                        </p-button>
                    </div>
                </div>
            </div>
        }

        <!-- Sektion: EI-Import-Fortschritt -->
        <div class="col-12">
            <hg-import-ei-progress
                    [eiImportId]="dto.eiImportDtoId"
                    [eiImportName]="dto.eiImportDtoName"
                    (onOpenEiImport)="openEiImport()">
            </hg-import-ei-progress>
        </div>

        <!-- Sektion: Fehler (nur bei status=ERROR) -->
        <div class="col-12">
            <hg-import-error-display
                    [errorMessage]="dto.errorMessage"
                    [status]="dto.status">
            </hg-import-error-display>
        </div>

        <!-- Aktion: Daten verifizieren -->
        <div class="col-12">
            <div class="surface-card p-3 border-round">
                <div class="flex align-items-center gap-2 mb-3">
                    <i class="fa-regular fa-circle-check text-primary"></i>
                    <span class="text-lg font-medium">Aktionen</span>
                </div>
                <div class="flex flex-column gap-3">
                    <p-button
                            label="Daten verifizieren"
                            icon="fa-regular fa-clipboard-check"
                            [loading]="busy"
                            [disabled]="busy || !dto.hgPartnerDtoId"
                            (onClick)="verifyImport()">
                    </p-button>

                    @if (verifyResult) {
                        <div class="grid">
                            <div class="col-12 md:col-6 lg:col-4">
                                <p-tag severity="info" value="Verträge: {{ verifyResult.contracts }}"></p-tag>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <p-tag severity="info" value="Vertragspersonen: {{ verifyResult.contractPersons }}"></p-tag>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <p-tag severity="info" value="Externe Daten: {{ verifyResult.contractExternalData }}"></p-tag>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <p-tag severity="info" value="Preise: {{ verifyResult.contractPrices }}"></p-tag>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <p-tag severity="info" value="Versicherbare Objekte: {{ verifyResult.contractInsurableObjects }}"></p-tag>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <p-tag severity="info" value="Externe Felder: {{ verifyResult.contractExternalFields }}"></p-tag>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <p-tag severity="info" value="Bankkonten: {{ verifyResult.contractExternalBankAccounts }}"></p-tag>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <p-tag severity="info" value="Deckungen: {{ verifyResult.contractCoverages }}"></p-tag>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <p-tag severity="info" value="Klauseln: {{ verifyResult.contractClauses }}"></p-tag>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}
